export const terms_data = [
  {
    title: "Clause 1",
    text: `Lorem ipsum dolor sit amet, consectetur adipiscing elit. Pellentesque nec erat enim. Nullam sapien nisi, vestibulum id ex sit amet, cursus feugiat eros. Pellentesque vestibulum semper molestie. Nam ac tellus sit amet nisi iaculis ultrices ut vitae dui. Vestibulum a posuere turpis. Proin lectus orci, pellentesque et mattis in, cursus sit amet velit. Nulla gravida sollicitudin porttitor. Cras sed neque finibus mauris varius interdum. Nulla facilisi.
Curabitur fringilla nec urna sit amet eleifend. Suspendisse sodales vitae tellus sit amet dictum. 
`,
  },
  {
    title: "Clause 2",
    text: `Vivamus condimentum blandit interdum. Donec ac placerat enim. Pellentesque elementum condimentum massa, id condimentum lorem maximus sit amet. Vivamus accumsan imperdiet urna, eget malesuada felis iaculis quis. Nunc orci neque, blandit nec lorem eu, mattis porta erat. Etiam et imperdiet tellus. Nulla ac gravida tellus. Integer imperdiet lorem sed mattis fermentum. Ut ultricies placerat sapien eu scelerisque. In eget lacus a arcu vulputate tempus. Maecenas eget rhoncus tellus. Donec ac justo tortor. Sed rhoncus, arcu sit amet accumsan mattis, urna ex sodales nunc, a volutpat justo erat nec quam.`,
  },
  {
    title: "Clause 3",
    text: `Morbi tincidunt dictum tempus. Morbi fringilla nibh sed convallis faucibus. Sed felis odio, pulvinar vel dolor id, euismod semper risus. Fusce semper imperdiet nisl, vel dapibus sem tincidunt non. Ut ligula est, tempus eu leo in, ultricies cursus risus. Nam luctus ex urna, et suscipit enim placerat sit amet. Nulla facilisi. Aliquam sit amet consequat odio. Etiam tempor varius tortor, vitae volutpat neque lacinia quis. In maximus diam ex, at porta ipsum commodo quis.
Sed consequat purus tortor. Quisque et nisi quis nisl malesuada molestie. Proin lacus eros, tincidunt at ornare eu, consectetur a lectus. Sed volutpat rutrum diam interdum gravida. Proin fringilla ante nibh, at interdum enim ultricies sit amet. Quisque sed eros sem. Nam vitae tellus odio.`,
  },
];

export const faq_header = [
  "Validating an Account",
  "Creating an Eyewitness Report",
  "Creating a Petition",
  "Creating a Representative Account",
  "Help and Support",
];

export const faq_question = [
  {
    id: 1,
    question: "Why do I need to verify my account?",
    answer:
      "Verification helps keep the platform secure by ensuring users are real and maintaining credibility, especially for those submitting reports or petitions.",
  },
  {
    id: 2,
    question: "How long does the verification process take?",
    answer: "",
  },
  {
    id: 3,
    question: "What documents are accepted for account verification?",
    answer: "",
  },
  {
    id: 4,
    question: "What documents are accepted for account verification?",
    answer: "",
  },
];
